module.exports = __webpack_public_path__ + "static/img/z2.6e2b597.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/z2.png
// module id = Culq
// module chunks = 0